import RequestV2 from './request-v2';

export default class ProductCostHttpService {
    private static uri = 'product/admin/cost';

    public static getProductCosts(params: any) {
        return RequestV2.get(`${this.uri}`, params);
    }

    public static async saveProductCost(cost: any) {
        return RequestV2.post(`${this.uri}`, cost);
    }

    public static async editProductCost(cost: any, id: number) {
        return RequestV2.put(`${this.uri}/${id}`, cost);
    }

    public static async deleteProductCost(id?: number) {
        return RequestV2.del(`${this.uri}/${id}`);
    }
}
